export default [
  { title: "A5", length: 22, width: 11, height: 5, type: 6 },
  { title: "A4", length: 31, width: 22, height: 5, type: 6 },
  { title: "A3", length: 30, width: 45, height: 5, type: 6 },
  { title: "سایز 1", length: 15, width: 10, height: 10, type: 1 },
  { title: "سایز 2", length: 20, width: 15, height: 10, type: 1 },
  { title: "سایز 3", length: 20, width: 20, height: 15, type: 1 },
  { title: "سایز 4", length: 30, width: 20, height: 20, type: 1 },
  { title: "سایز 5", length: 35, width: 25, height: 20, type: 1 },
  { title: "سایز 6", length: 45, width: 25, height: 20, type: 1 },
  { title: "سایز 7", length: 40, width: 30, height: 25, type: 1 },
  { title: "سایز 8", length: 45, width: 40, height: 30, type: 1 },
  { title: "سایز 9", length: 55, width: 45, height: 35, type: 1 },
];
